import ModuleClientsIndex from "../shared/moduleClients/ModuleClientsIndex";
import { MODULE_CLIENT_CONFIGS } from "../shared/moduleClients/moduleClientConfigs";

export default function SkillAssessment() {
  return <ModuleClientsIndex config={MODULE_CLIENT_CONFIGS.skill} />;
}
